// External dependencies
import PropTypes from 'prop-types';
import React, { Component } from 'react';

// Internal dependencies
import { getOffers } from '../api/offers.api';

import OfferPricingPresentational from './OfferPricingPresentational';

export class OfferPricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offer: {},
      isLoading: true,
      isOwnOffer: false,
    };
  }

  async componentDidMount() {
    const { profile, authUser } = this.props;
    if (!profile) {
      this.setState(() => ({ isLoading: false }));
      return;
    }
    if (profile._id) {
      const offers = await getOffers(profile._id, 'host');
      this.setState(() => ({
        isLoading: false,
        offer: offers?.[0] ?? { status: 'no' },
        isOwnOffer: authUser && authUser._id && authUser._id === profile._id,
      }));
    }
  }

  render() {
    const { offer, isOwnOffer } = this.state;

    return (
      <OfferPricingPresentational
        offer={offer}
        isOwnOffer={isOwnOffer}
        username={this.props.profile.username}
      />
    );
  }
}

OfferPricing.propTypes = {
  authUser: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

export default OfferPricing;
